import type { TaskType } from '@api';
import { SimpleGrid } from '@mantine/core';
import { TaskDetailsContent } from '../TaskDetailsContent';
import { TaskSystemMetadata } from '../TaskSystemMetadata';

type TaskDetailsDisplayPropsType = {
  task: TaskType;
};

export const TaskDetailsDisplay: React.FC<TaskDetailsDisplayPropsType> = ({
  task,
}) => (
  <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="sm">
    <TaskDetailsContent task={task} />
    <TaskSystemMetadata task={task} />
  </SimpleGrid>
);
